import { render, staticRenderFns } from "./StarkenModalComponent.vue?vue&type=template&id=2262e677&scoped=true&"
import script from "./StarkenModalComponent.vue?vue&type=script&lang=js&"
export * from "./StarkenModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./StarkenModalComponent.vue?vue&type=style&index=0&id=2262e677&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262e677",
  null
  
)

export default component.exports